export default {
  gewerbe: {
    hero: {
      eyebrow: 'Clientes empresariales',
      title: 'Videovigilancia profesional para necesidades empresariales',
      lead: 'De la sucursal minorista a la nave de producción: planificamos, instalamos y mantenemos sistemas de cámaras al servicio de su negocio. Con privacidad, escalable y fiable.',
    },
    types: {
      title: 'Soluciones para su negocio',
      lead: 'Cada sector tiene sus propias necesidades. Conocemos los retos típicos y planificamos en consecuencia.',
      items: {
        '0': { title: 'Comercio y tiendas', desc: 'Entrada, sala de ventas, caja y almacén: vigilados de forma discreta y eficaz. Protección contra robos y vandalismo.', tags: { '0': 'Interior', '1': 'Antirrobo', '2': 'Caja' } },
        '1': { title: 'Oficinas y consultas', desc: 'Recepción, pasillos, zonas sensibles y aparcamientos, con derechos de acceso y zonas privadas.', tags: { '0': 'Interior', '1': 'Recepción', '2': 'Privacidad' } },
        '2': { title: 'Almacén y logística', desc: 'Vigilancia de grandes superficies con gran angular y PTZ. Visión de zonas de entrega, estanterías y exteriores día y noche.', tags: { '0': 'Interior', '1': 'Exterior', '2': 'Visión nocturna' } },
        '3': { title: 'Hostelería', desc: 'Entrada, barra, acceso a cocina y exterior: cámaras robustas para ambientes húmedos y calurosos.', tags: { '0': 'Interior', '1': 'Exterior', '2': 'Robusto' } },
        '4': { title: 'Talleres e industria', desc: 'Entornos más exigentes requieren cámaras especialmente robustas. Talleres, exteriores y muelles, protegidos del polvo y la intemperie.', tags: { '0': 'Interior', '1': 'Robusto', '2': 'Visión nocturna' } },
        '5': { title: 'Varias ubicaciones', desc: 'Acceso central a todas las cámaras desde una sola app. Gestión de usuarios con derechos diferenciados.', tags: { '0': 'Multi-sede', '1': 'Central', '2': 'App' } },
      },
    },
    features: {
      title: 'Funciones para uso empresarial',
      lead: 'Las instalaciones comerciales requieren más que cámaras. Configuramos derechos, horarios de grabación y notificaciones de forma profesional.',
      items: {
        '0': { title: 'Gestión de usuarios', desc: 'Diferentes derechos de acceso para empleados, encargados y dirección. ¿Quién puede ver qué cámara?' },
        '1': { title: 'Grabación y archivo', desc: 'Grabador local con almacenamiento redundante. Duración según requisitos operativos y legales.' },
        '2': { title: 'Notificaciones de eventos', desc: 'Avisos push ante movimiento, cruce de línea o eventos definidos, según el sistema.' },
        '3': { title: 'Ampliabilidad', desc: '¿Su empresa crece? Los sistemas existentes suelen poder ampliarse con más cámaras y sedes.' },
      },
    },
    legal: {
      eyebrow: 'Protección de datos y derecho',
      title: 'Videovigilancia empresarial conforme a la ley',
      lead: 'En la videovigilancia comercial se aplican normas adicionales, sobre todo respecto a empleados, clientes y zonas públicas. Le apoyamos con la implementación técnica de:',
      list: {
        '0': 'Transparencia y señalización en las entradas',
        '1': 'Enmascaramiento de vestuarios y salas de descanso',
        '2': 'Implementación técnica de derechos de acceso y usuarios',
        '3': 'Almacenamiento local con plazo de conservación definido',
        '4': 'Documentación de la necesidad operativa',
      },
      note: 'Nota: la legalidad de la videovigilancia empresarial depende del caso. Le asesoramos técnicamente, sin sustituir el asesoramiento jurídico.',
    },
    cta: {
      title: 'Su negocio merece seguridad profesional',
      lead: 'Analizamos sus procesos y planificamos un sistema que protege sin molestar. Sin compromiso y con transparencia.',
      primary: 'Concertar una cita de asesoría',
      secondary: 'Descubrir SSG Care',
    },
  },
};